import { __assign, __awaiter, __generator } from "tslib";
import { app } from '@ekuaibao/whispered';
import { Fetch } from '@ekuaibao/fetch';
import { logoutGuanYuanReport } from '../account.action';
import { isIdpLogin } from './utilSource';
import { session } from '@ekuaibao/session-info';
import { getMachineCaptchaPayload, preloadMachineCaptcha } from './captcha';
var MUL_AUTH_SUCCESS = 'success';
export var serializeCorpList = function (_a) {
    var _b = _a.items, items = _b === void 0 ? [] : _b, _c = _a.externalItems, externalItems = _c === void 0 ? [] : _c;
    return items.concat(externalItems).map(function (item) { return item === null || item === void 0 ? void 0 : item.corporation; });
};
export var switchCorporation = function (corporation, options) { return __awaiter(void 0, void 0, void 0, function () {
    var corporationId, needMulAuth, resp, needAuthObj, ncpcData, result, error_1, openedBiReport, cloudAuthToken_1, checkInApplication;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    return __generator(this, function (_q) {
        switch (_q.label) {
            case 0:
                corporationId = corporation.id;
                needMulAuth = (_a = options === null || options === void 0 ? void 0 : options.needMulAuth) !== null && _a !== void 0 ? _a : true;
                if (!needMulAuth) return [3 /*break*/, 7];
                _q.label = 1;
            case 1:
                _q.trys.push([1, 6, , 7]);
                preloadMachineCaptcha();
                return [4 /*yield*/, app.invokeService('@account5:check:multiauth', {
                        targetCorpId: corporationId,
                    })];
            case 2:
                resp = _q.sent();
                needAuthObj = resp.value;
                if (!(needAuthObj === null || needAuthObj === void 0 ? void 0 : needAuthObj.needAuth)) return [3 /*break*/, 5];
                return [4 /*yield*/, getMachineCaptchaPayload(0)];
            case 3:
                ncpcData = _q.sent();
                return [4 /*yield*/, app.open('@account5:Check2FactorAuthModal', __assign(__assign({}, needAuthObj), { targetCorpId: corporationId, ncpcData: ncpcData }))];
            case 4:
                result = _q.sent();
                if (result !== MUL_AUTH_SUCCESS) {
                    return [2 /*return*/, (_c = (_b = options === null || options === void 0 ? void 0 : options.mulAuthModalOptions) === null || _b === void 0 ? void 0 : _b.onCancel) === null || _c === void 0 ? void 0 : _c.call(_b)];
                }
                _q.label = 5;
            case 5: return [3 /*break*/, 7];
            case 6:
                error_1 = _q.sent();
                console.log(error_1);
                return [2 /*return*/, (_e = (_d = options === null || options === void 0 ? void 0 : options.mulAuthModalOptions) === null || _d === void 0 ? void 0 : _d.onCancel) === null || _e === void 0 ? void 0 : _e.call(_d)];
            case 7:
                if (corporation.sourceChannel === 'V1') {
                    return [2 /*return*/, location.replace(corporation.sourceId)];
                }
                openedBiReport = localStorage.getItem('openedBiReport');
                if (openedBiReport) {
                    localStorage.removeItem('openedBiReport');
                    // 调用Bi报表退出接口
                    logoutGuanYuanReport();
                }
                if (isIdpLogin() && !!((_f = app.sdk) === null || _f === void 0 ? void 0 : _f.switchCorporation)) {
                    // 清理费控的授权信息的缓存
                    session.remove('user');
                    return [2 /*return*/, (_g = app.sdk) === null || _g === void 0 ? void 0 : _g.switchCorporation(corporation)];
                }
                else {
                    // 清理可能存在的idp缓存
                    (_j = (_h = app.sdk) === null || _h === void 0 ? void 0 : _h.logout) === null || _j === void 0 ? void 0 : _j.call(_h);
                }
                if (!(localStorage.getItem('enableCloudAuth') === 'true')) return [3 /*break*/, 9];
                session.remove('user');
                cloudAuthToken_1 = localStorage.getItem('cloudAuthToken') || undefined;
                return [4 /*yield*/, window.fetch(window.PLATFORMINFO.cloudAuthUrl + "/cloud-auth/public/auth/switch-corporation", {
                        method: 'POST',
                        credentials: 'include',
                        headers: {
                            'Content-Type': 'application/json',
                            'cloud-auth-token': cloudAuthToken_1
                        },
                        body: JSON.stringify({
                            corporationId: corporation.id,
                            userId: corporation.userId,
                            cluster: corporation.cluster
                        })
                    }).then(function (res) { return res.json(); }).then(function (result) {
                        var authCode = result.data.accessToken;
                        location.replace(corporation.baseUrl + "web/app.html?corpId=" + corporation.id + "&ekbCorpId=" + corporation.id + "&authCode=" + authCode + "&cloudAuthToken=" + cloudAuthToken_1);
                    })];
            case 8: return [2 /*return*/, _q.sent()];
            case 9:
                if (!(options === null || options === void 0 ? void 0 : options.checkSSOLogin)) return [3 /*break*/, 11];
                return [4 /*yield*/, check(app.invokeService('@account5:checkOnlySSOLogin', corporationId), function (onlySSOLogin) { return !onlySSOLogin; })];
            case 10:
                _q.sent();
                _q.label = 11;
            case 11:
                checkInApplication = (_l = (_k = options === null || options === void 0 ? void 0 : options.pwdExpireModalOptions) === null || _k === void 0 ? void 0 : _k.checkInApplication) !== null && _l !== void 0 ? _l : true;
                // 判断是否过期
                return [4 /*yield*/, check(app.invokeService('@account5:password:expire:modal', {
                        corpId: corporationId,
                        checkInApplication: checkInApplication,
                        preExecute: (_m = options === null || options === void 0 ? void 0 : options.pwdExpireModalOptions) === null || _m === void 0 ? void 0 : _m.preExecute,
                        cancelCallback: (_o = options === null || options === void 0 ? void 0 : options.pwdExpireModalOptions) === null || _o === void 0 ? void 0 : _o.onCancel,
                        okCallback: (_p = options === null || options === void 0 ? void 0 : options.pwdExpireModalOptions) === null || _p === void 0 ? void 0 : _p.onOk
                    }), function (pwdUnExpire) { return pwdUnExpire; })];
            case 12:
                // 判断是否过期
                _q.sent();
                session.set('user', {
                    isChangeCorp: true,
                    accessToken: Fetch.accessToken,
                    corpId: corporationId,
                    userId: Fetch.userId,
                    ekbCorpId: corporationId,
                });
                Fetch.ekbCorpId = corporationId;
                // 记录系统日志
                app.invokeService('@corporation-info:switchcorporationForLog', corporationId);
                app.invokeService('@account5:refreshToBills');
                return [2 /*return*/];
        }
    });
}); };
var check = function (requestCondition, validator) { return __awaiter(void 0, void 0, void 0, function () {
    var result, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, requestCondition];
            case 1:
                result = _a.sent();
                if (validator(result)) {
                    return [2 /*return*/, Promise.resolve()];
                }
                return [2 /*return*/, Promise.reject('unPass')];
            case 2:
                e_1 = _a.sent();
                return [2 /*return*/, Promise.resolve()];
            case 3: return [2 /*return*/];
        }
    });
}); };
